import { combineReducers } from 'redux';
import general from './general/reducer';
import company from './company/reducer';
import na from './na/reducer';
import warning from './warning/reducer';
import externalAccessConfig from './externalAccess/reducer';
import { userReducer as user } from './user/reducer';

export default combineReducers({
  general,
  company,
  na,
  warning,
  user,
  externalAccessConfig,
});
